import { createFileRoute, notFound } from "@tanstack/react-router";
import { getVendor, vendorSlugs } from "@/lib/vendors";
import { VendorRegistrationPage } from "@/components/VendorRegistrationPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

const AREA = [
  { type: "Country" as const, name: "Iraq" },
  { type: "Place" as const, name: "Kurdistan Region of Iraq" },
];

export const Route = createFileRoute("/services/oil-gas-registration/$operator")({
  beforeLoad: ({ params }) => {
    if (!vendorSlugs.includes(params.operator)) throw notFound();
  },
  head: ({ params }) => {
    const v = getVendor(params.operator);
    if (!v || !vendorSlugs.includes(params.operator)) return {};
    const path = `/services/oil-gas-registration/${v.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: v.metaTitle.en },
        { name: "description", content: v.description.en },
        { property: "og:title", content: v.metaTitle.en },
        { property: "og:description", content: v.description.en },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: v.image ? absolute(v.image.src) : OG_IMAGE },
        { name: "twitter:image", content: v.image ? absolute(v.image.src) : OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: v.title.en,
                serviceType: `${v.name.en} vendor registration`,
                description: v.description.en,
                areaServed: v.areaServed ?? AREA,
              }),
              faqPage(
                path,
                v.faq.map((f) => ({ q: f.q.en, a: f.a.en })),
              ),
              breadcrumbList([
                { name: "Home", path: "/" },
                { name: "Services", path: "/services" },
                { name: "Oil & Gas Registration", path: "/services/oil-gas-registration" },
                { name: v.name.en, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: VendorOperatorPage,
});

function VendorOperatorPage() {
  const { operator } = Route.useParams();
  const v = getVendor(operator);
  if (!v || !vendorSlugs.includes(operator)) throw notFound();
  return <VendorRegistrationPage operator={v} />;
}
